import axios from 'axios';
import fingerprint from 'browser-fingerprint';
import NotificationUtil from '../utils/notification.util';
import localStorageKeys from './localStorageKeys';

const axiosService = axios.create({
  baseURL: process.env.REACT_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
  },
});

export const axiosClient = axios.create();

const token = localStorage.getItem(localStorageKeys.moichorToken);
axiosService.defaults.headers.common.Authorization = (token) ? `Bearer ${token}` : null;

axiosService.interceptors.request.use(async (req) => {
  if ((req.method === 'post' || req.method === 'patch') && req.data) {
    Object.keys(req.data).forEach((k) => {
      req.data[k] = typeof req.data[k] === 'string' ? req.data[k].trim() : req.data[k];
    });
  }
  if (req.method === 'get' && req.params && typeof req.params === 'object') {
    Object.keys(req.params).forEach((k) => {
      if (typeof req.params[k] === 'string') {
        req.params[k] = req.params[k].trim();
      }
    });
  }
  return req;
});

axiosService.interceptors.response.use(
  (res) => res,
  async (error) => {
    let { message, name } = ['', ''];
    if (error.response && error.response.data && error.response.data.error) {
      const e = error.response?.data?.error;
      message = error.response?.data?.message ?? e.message;
      name = e.name;
    } else if (error.response && error.response.data && error.response.data.message) {
      message = error.response.data.message;
    }
    if (name === 'RenewSessionError'
      || message === 'JsonWebTokenError'
      || message === 'Invalid authentication token'
      || message === 'Invalid initialization vector') {
      localStorage.removeItem(localStorageKeys.moichorToken);
      localStorage.removeItem(localStorageKeys.moichorUser);
      localStorage.removeItem(localStorageKeys.moichorRefreshToken);
      // eslint-disable-next-line no-restricted-globals
      location.reload();
    } else if (message === 'TokenExpiredError') {
      const originalRequest = error.config;
      const refreshToken = localStorage.getItem(localStorageKeys.moichorRefreshToken);
      const accessToken = localStorage.getItem(localStorageKeys.moichorToken);

      if (originalRequest.data) {
        if (originalRequest.params && originalRequest.params.cf_type && originalRequest.params.cf_type === 8);
        else originalRequest.data = JSON.parse(originalRequest.data);
      }
      const code = fingerprint();
      try {
        const { data } = await axios.post(
          `${process.env.REACT_APP_BASE_API}/api/v1/auth/refresh-token`,
          {
            refreshToken, accessToken, code,
          },
        );
        if (data) {
          const { accessToken, refreshToken } = data;
          localStorage.setItem(localStorageKeys.moichorToken, accessToken);
          localStorage.setItem(localStorageKeys.moichorRefreshToken, refreshToken);

          axiosService.defaults.headers.common.Authorization = `Bearer ${accessToken}`;
          originalRequest.headers.Authorization = `Bearer ${accessToken}`;

          return new Promise((resolve, reject) => {
            axios(originalRequest)
              .then((response) => {
                resolve(response);
              })
              .catch((error) => {
                reject(error);
              });
          });
        }
      } catch (error) {
        localStorage.removeItem(localStorageKeys.moichorToken);
        localStorage.removeItem(localStorageKeys.moichorUser);
        localStorage.removeItem(localStorageKeys.moichorRefreshToken);
        // eslint-disable-next-line no-restricted-globals
        location.reload();
      }
    }
    const notification = (typeof message === 'object' && Object.prototype.hasOwnProperty.call(message, 'name')) ? message.name : message;
    if (notification) {
      NotificationUtil.error(notification);
    } else if (error.response?.data?.message) {
      NotificationUtil.error(error.response.data.message);
    }
    return Promise.reject(error.response);
  },
);

export default axiosService;
